<app-navbar></app-navbar>
<main>
  <router-outlet></router-outlet>
</main>
@if (showGlobalFooter()) {
  <app-footer></app-footer>
}
<app-toast></app-toast>
<app-confirmation-modal></app-confirmation-modal>



